import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Blog from "./pages/Blog";
import About from './pages/About';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import AdultServices from './pages/AdultServices';
import ChildServices from './pages/ChildServices';
import InpatientPrograms from './pages/InpatientPrograms';
import Doctors from './pages/Doctors';
// import Contact from './pages/Contact';
// Individual Adult Service Pages
import Depression from './pages/services/Depression';
import Anxiety from './pages/services/Anxiety';
import FamilyCounseling from './pages/services/FamilyCounseling';
import BipolarDisorder from './pages/services/BipolarDisorder';
import ObsessiveDisorder from './pages/services/ObsessiveDisorder';
import AngerManagement from './pages/services/AngerManagement';
import PersonalityDisorders from './pages/services/PersonalityDisorders';
import BehavioralAddictions from './pages/services/BehavioralAddictions';
import PsychosisProblem from './pages/services/PsychosisProblem';
import LGBTPsychiatry from './pages/services/LGBTPsychiatry';
import DeAddictionCounseling from './pages/services/DeAddictionCounseling';
import GeriatricsMentalHealth from './pages/services/GeriatricsMentalHealth';
import SelfEsteemBuilding from './pages/services/SelfEsteemBuilding';
import WorkRelatedStress from './pages/services/WorkRelatedStress';
import WomensMentalHealth from './pages/services/WomensMentalHealth';
import SeverePsychiatricDisorders from './pages/services/SeverePsychiatricDisorders';
// Individual Child Service Pages
import IndividualPlayTherapy from './pages/services/IndividualPlayTherapy';
import SpeechTherapy from './pages/services/SpeechTherapy';
import OccupationalTherapy from './pages/services/OccupationalTherapy';
import SpecialEducation from './pages/services/SpecialEducation';
import GroupTherapy from './pages/services/GroupTherapy';
import PsychologicalTesting from './pages/services/PsychologicalTesting';
import TeenSensitiveServices from './pages/services/TeenSensitiveServices';
import TraumaOutreach from './pages/services/TraumaOutreach';
import CrisisIntervention from './pages/services/CrisisIntervention';
import EatingDisorderTreatment from './pages/services/EatingDisorderTreatment';
import ConsultationForChildCare from './pages/services/ConsultationForChildCare';
import AssessmentProgram from './pages/services/AssessmentProgram';
import InfantParentPrograms from './pages/services/InfantParentPrograms';
import InformationReferral from './pages/services/InformationReferral';
// Inpatient Care
import InpatientCare from './pages/services/InpatientCare';
import './index.css';

// Scroll to top component
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const EnquiryHandoff = ({ children }) => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (pathname === '/enquiry' || pathname === '/enquiry/') {
      window.location.replace(`/enquiry/index.php${search}`);
    }
  }, [pathname, search]);

  if (pathname === '/enquiry' || pathname === '/enquiry/') {
    return null;
  }

  return children;
};

function App() {
  return (
    <Router>
      <EnquiryHandoff>
        <ScrollToTop />
        <div className="min-h-screen flex flex-col w-full overflow-x-hidden">
          <Navbar />
          <main className="flex-grow w-full">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/blog" element={<Blog />} /> 
              <Route path="/about" element={<About />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/services/adult" element={<AdultServices />} />
              <Route path="/services/child" element={<ChildServices />} />
              <Route path="/services/inpatient" element={<InpatientPrograms />} />
              <Route path="/doctors" element={<Doctors />} />
              {/* <Route path="/contact" element={<Contact />} /> */}
              {/* Individual Adult Service Routes */}
              <Route path="/services/depression" element={<Depression />} />
              <Route path="/services/anxiety" element={<Anxiety />} />
              <Route path="/services/family-counseling" element={<FamilyCounseling />} />
              <Route path="/services/bipolar-disorder" element={<BipolarDisorder />} />
              <Route path="/services/obsessive-disorder" element={<ObsessiveDisorder />} />
              <Route path="/services/anger-management" element={<AngerManagement />} />
              <Route path="/services/personality-disorders" element={<PersonalityDisorders />} />
              <Route path="/services/behavioral-addictions" element={<BehavioralAddictions />} />
              <Route path="/services/psychosis-problem" element={<PsychosisProblem />} />
              <Route path="/services/lgbt-psychiatry" element={<LGBTPsychiatry />} />
              <Route path="/services/de-addiction-counseling" element={<DeAddictionCounseling />} />
              <Route path="/services/geriatrics-mental-health" element={<GeriatricsMentalHealth />} />
              <Route path="/services/self-esteem-building" element={<SelfEsteemBuilding />} />
              <Route path="/services/work-related-stress" element={<WorkRelatedStress />} />
              <Route path="/services/womens-mental-health" element={<WomensMentalHealth />} />
              <Route path="/services/severe-psychiatric-disorders" element={<SeverePsychiatricDisorders />} />
              {/* Individual Child Service Routes */}
              <Route path="/services/individual-play-therapy" element={<IndividualPlayTherapy />} />
              <Route path="/services/speech-therapy" element={<SpeechTherapy />} />
              <Route path="/services/occupational-therapy" element={<OccupationalTherapy />} />
              <Route path="/services/special-education" element={<SpecialEducation />} />
              <Route path="/services/group-therapy" element={<GroupTherapy />} />
              <Route path="/services/psychological-testing" element={<PsychologicalTesting />} />
              <Route path="/services/teen-sensitive-services" element={<TeenSensitiveServices />} />
              <Route path="/services/trauma-outreach" element={<TraumaOutreach />} />
              <Route path="/services/crisis-intervention" element={<CrisisIntervention />} />
              <Route path="/services/eating-disorder-treatment" element={<EatingDisorderTreatment />} />
              <Route path="/services/caregivers-consultation" element={<ConsultationForChildCare />} />
              <Route path="/services/assessment-program" element={<AssessmentProgram />} />
              <Route path="/services/infant-parent-programs" element={<InfantParentPrograms />} />
              <Route path="/services/information-referral" element={<InformationReferral />} />
              {/* Inpatient Care Route */}
              <Route path="/services/inpatient-care" element={<InpatientCare />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </EnquiryHandoff>
    </Router>
  );
}

export default App;
